export default function ButtonArrow() {
  return (
    <svg viewBox="0 0 24 24"><path d="M12 8V4l8 8-8 8v-4H4V8z"></path></svg>
  )
}
